import UAParser from "ua-parser-js";

const parser = new UAParser();
const deviceType = parser.getDevice().type;

export const os = () => parser.getOS().name.toLowerCase();

export const isMobile = () => deviceType === "mobile";

export const isTablet = () => deviceType === "tablet";

export const isDesktop = () => deviceType === "desktop";

export const isChrome = () => parser.getBrowser().name.toLowerCase().indexOf("chrome") >= 0;

export default parser;
